<template>
  <div class="border-bottom">
    <div class="row align-items-center">
      <div class="col">
        <span v-text="text" />
      </div>
      <div class="col-12 col-md-5 col-lg-4 col-xl-3">
        <ValidationProvider
          v-slot="{ errors }"
          :disabled="!validate"
          mode="lazy"
          :rules="{ required: true, is_not: 0 }"
          :custom-messages="{
            required: 'Favor seleccione una opción.',
            is_not: 'Favor seleccione una opción.',
          }"
        >
          <div class="d-flex justify-content-end">
            <div class="text-nowrap nowrap-radio">
              <CustomRadio
                :disabled="readonly"
                is-question-list
                :is-disabled="false"
                :error="!!errors[0]"
                :custom-error-msg="errors[0] || ''"
                :options="optionsWithState"
                :change-event="onChange"
              />
            </div>
          </div>
          <input v-model="value" type="hidden" />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomRadio from 'custom-radio';
import { AlternativeStatusEnum } from '../_types';

export default {
  name: 'AlternativeCreationQuestion',
  components: { CustomRadio },
  props: {
    text: { type: String, default: null },
    value: { type: [String, Number], default: null },
    readonly: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
  },
  data: () => ({
    options: [
      {
        id: AlternativeStatusEnum.Yes,
        label: 'Sí',
        check: false,
        invalid: false,
        disabled: false,
      },
      {
        id: AlternativeStatusEnum.InProcess,
        label: 'En Proceso',
        check: false,
        invalid: false,
        disabled: false,
      },
      {
        id: AlternativeStatusEnum.No,
        label: 'No',
        check: false,
        invalid: false,
        disabled: false,
      },
    ],
  }),
  computed: {
    optionsWithState() {
      return this.options.map((x) => ({ ...x, check: this.value == x.id }));
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value.id);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .nowrap-radio .custom-radio-container > div {
  border-top: 1px solid lightgray;
  border-right: 1px solid lightgray;
  &:first-child {
    border-left: 1px solid lightgray;
    border-top-left-radius: 5px;
  }
  &:last-child {
    border-top-right-radius: 5px;
  }
  background-color: white !important;
  .custom-radio-button {
    width: 100px;
    margin-right: 0;
    border-radius: 0 !important;
    &.bg-gray {
      background-color: transparent !important;
    }
  }
}
</style>
